import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { LoginDesktop } from './LoginDesktop';
import { LoginMobile } from './LoginMobile';

const SignIn = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  return <>{isMobileScreen ? <LoginMobile /> : <LoginDesktop />}</>;
};

export default SignIn;
